module.exports = __webpack_public_path__ + "sabot.png?c6e95d3cf1437e545176022bc61b8e52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sabot.png
// module id = 127
// module chunks = 0